import React, { useState } from "react";
import { Modal, Spinner } from "react-bootstrap";

import { useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { onHideSaveModal } from "../../store/slice/modalSlice";
import { fetchMappings } from "../../store/slice/mappingSlice";

import { onSaveMappings } from "../mappingWindow/Configurator";

const SaveModal = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  const { showSaveModal } = useSelector((state) => state.modal);
  const { isBtnDisabled, saveModalMessage, selectedCountry, defaultMappings } =
    useSelector((state) => state.mapping);

  const discardChanges = () => {
    const companyId = searchParams.get("companyId");
    dispatch(fetchMappings(companyId));

    dispatch(onHideSaveModal());
  };

  const saveChanges = async () => {
    setSaveBtnLoading(true);
    await onSaveMappings({
      setSaveBtnLoading,
      defaultMappings,
      searchParams,
      dispatch,
    });
    setSaveBtnLoading(false);
    dispatch(onHideSaveModal());
  };

  return (
    <div>
      <Modal
        className="my-modal"
        show={showSaveModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="delete-modal p-4">
          <p>
            {isBtnDisabled
              ? `${saveModalMessage[selectedCountry]}`
              : "You have unsaved changes. Please click on save or else you can discard the changes."}
          </p>
          <div className="d-flex flex-row justify-content-end">
            {isBtnDisabled && (
              <button
                className="delete-modal-cancel-btn"
                onClick={() => dispatch(onHideSaveModal())}
              >
                Edit
              </button>
            )}
            {!isBtnDisabled && (
              <button
                className="delete-modal-discard-btn me-3"
                onClick={() => discardChanges()}
              >
                Discard
              </button>
            )}
            {!isBtnDisabled && (
              <button
                className="save-mapping-button"
                onClick={() => saveChanges()}
              >
                {saveBtnLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span>Save changes</span>
                )}
              </button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SaveModal;
